<template>
  <div v-if="DATinfo" class="datinfo" v-bind:class="{ openE : eOpen }">
    
    <h4 v-on:click="toggleOpen"><i class="fa fa-chevron-right"></i><span><strong>{{DATinfo.data.ManufacturerName.value}} {{DATinfo.data.BaseModelName.value}} {{DATinfo.data.SubModelName.value}}</strong><br>{{ getHumanDate() }} {{DATinfo.vin}} {{DATinfo.baujahr}}</span> </h4>

    <div class="datinfo_container">
      <div class="columns">
        <div class="column">
          <dl>
            <dt v-if="DATinfo.data.ManufacturerName">{{DATinfo.data.ManufacturerName.title}}</dt><dd>{{DATinfo.data.ManufacturerName.value}}</dd>
            <dt v-if="DATinfo.data.BaseModelName">{{DATinfo.data.BaseModelName.title}}</dt><dd>{{DATinfo.data.BaseModelName.value}}</dd>
            <dt v-if="DATinfo.data.SubModelName">{{DATinfo.data.SubModelName.title}}</dt><dd>{{DATinfo.data.SubModelName.value}}</dd>
            <dt v-if="DATinfo.data.DatECode">{{DATinfo.data.DatECode.title}}</dt><dd>{{DATinfo.data.DatECode.value}} {{DATinfo.data.Container.value}}</dd>
            <dt v-if="DATinfo.data.Leistung">{{DATinfo.data.Leistung.title}}</dt><dd>{{DATinfo.data.Leistung.value}}</dd>
            <dt v-if="DATinfo.data.Hubraum">{{DATinfo.data.Hubraum.title}}</dt><dd>{{DATinfo.data.Hubraum.value}}</dd>
            <dt v-if="DATinfo.data.Motorart">{{DATinfo.data.Motorart.title}}</dt><dd>{{DATinfo.data.Motorart.value}}</dd>
            <dt v-if="DATinfo.data.Getriebe">{{DATinfo.data.Getriebe.title}}</dt><dd>{{DATinfo.data.Getriebe.value}}</dd>
          </dl>
  
          <dl>
            <dt v-if="DATinfo.data.Color">{{DATinfo.data.Color.title}}</dt><dd>{{DATinfo.data.Color.value}}</dd>
            <dt v-if="DATinfo.data.SeatsDoors">{{DATinfo.data.SeatsDoors.title}}</dt><dd>{{DATinfo.data.SeatsDoors.value}}</dd>
            <dt v-if="DATinfo.data.KBA">{{DATinfo.data.KBA.title}}</dt><dd>{{DATinfo.data.KBA.value}}</dd>
            <dt v-if="DATinfo.data.Mileage">{{DATinfo.data.Mileage.title}}</dt><dd>{{DATinfo.data.Mileage.value}}</dd>
          </dl>
          <h3>Bewertung</h3>
          <dl>
            <dt v-if="DATinfo.data.OriginalPriceGross">{{DATinfo.data.OriginalPriceGross.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.OriginalPriceGross.value ) }}</dd>
            <dt v-if="DATinfo.data.EquipmentOriginalPrice">{{DATinfo.data.EquipmentOriginalPrice.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.EquipmentOriginalPrice.value )}}</dd>
            <dt v-if="DATinfo.data.OriginalPriceGrossGesamt">{{DATinfo.data.OriginalPriceGrossGesamt.title}}</dt><dd class="ddprice" >{{  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.OriginalPriceGrossGesamt.value ) }}</dd>
          </dl>
  
          <dl>
            <dt v-if="DATinfo.data.RichtwertDAT">{{DATinfo.data.RichtwertDAT.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.RichtwertDAT.value ) }}</dd>
            <dt v-if="DATinfo.data.MileageCorr">{{DATinfo.data.MileageCorr.title}} ({{DATinfo.data.ReferenceMileage.value}}km)</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.MileageCorr.value ) }}</dd>
            <dt v-if="DATinfo.data.InitialRegistrationCorr">{{DATinfo.data.InitialRegistrationCorr.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.InitialRegistrationCorr.value )}}</dd>
          </dl>
  
          <dl>
            <dt v-if="DATinfo.data.BasiswertDATErmittlung">{{DATinfo.data.BasiswertDATErmittlung.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(DATinfo.data.BasiswertDATErmittlung.value ) }}</dd>
            <dt v-if="DATinfo.data.SalesPriceGross">{{DATinfo.data.SalesPriceGross.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.SalesPriceGross.value ) }}</dd>
            <dt v-if="DATinfo.data.Grundwert">{{DATinfo.data.Grundwert.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.Grundwert.value ) }}</dd>
          </dl>
  
          <dl class="bold">
            <dt v-if="DATinfo.data.SalesPrice">{{DATinfo.data.SalesPrice.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.SalesPrice.value ) }}</dd>
            <dt v-if="DATinfo.data.EquipmentPrice">{{DATinfo.data.EquipmentPrice.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.EquipmentPrice.value ) }}</dd>
            <dt v-if="DATinfo.data.PurchasePriceGross">{{DATinfo.data.PurchasePriceGross.title}}</dt><dd class="ddprice" >{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( DATinfo.data.PurchasePriceGross.value ) }}</dd>
          </dl>

        </div>
        <div class="column">
          <div id="ausstattung">
            
              <div class="sonderausstattung ausstattung">
                <h3>Sonderausstattung</h3>
                <ul v-for="(item, key, index) in DATinfo.data.SpecialEquipment.value" v-bind:key="key">
                  <li v-if=" item.Description ">{{item.Description.value}}</li>
                </ul>
              </div>
  
              <div class="serienausstattung ausstattung">
                <h3>Serienausstattung</h3>
                <ul v-for="(item, key, index) in DATinfo.data.SeriesEquipment.value" v-bind:key="key">
                  <li v-if=" item.Description ">{{item.Description.value}}</li>
                </ul>  
              </div>
              
          </div>
        </div>
        
    </div>
  </div>
  </div>
</template>
<script>
export default {
  name: "DatFastRequest",
  props: ['datrequest'],
  data() {
    return {
        DATinfo: {},
        eOpen: false
        }
  },

  methods: {
    showProperty(e){
    e.preventDefault();
    },
    toggleOpen: function(e){
        this.eOpen = this.eOpen ? false : true; //$(e.currentTarget).parent('.email').toggleClass('openE');
    },
      getHumanDate(){
      var d = new Date( this.DATinfo.data.CreateDate.value )
      this.FormattedDate =  d.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' } ) + " " + d.toLocaleTimeString('de-DE'); //d.getDate() + "." + d.getMonth() + "." + d.getFullYear() + " "  + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()
      return this.FormattedDate
    }

  },
  created: function(){
    this.DATinfo.data = this.datrequest.data.data;
    this.eOpen = false;
    this.DATinfo.vorgangsnummer = this.datrequest.data.vorgangsnummer;
    this.DATinfo.vin = this.datrequest.data.vin;
    this.DATinfo.baujahr = this.datrequest.data.baujahr;
    this.DATinfo.laufleistung = this.datrequest.data.laufleistung;
  }
}
</script>
<style scoped>	
  .datinfo_container { padding: 0.9333333em 0; }
  .datinfo { height: auto; border-bottom: 1px solid #ddd; padding: 0.9333333em 0; }
  .datinfo:last-child { border: 0; }
  .datinfo dl { display: flex; flex-wrap: wrap; align-content: flex-start; align-items: flex-end; padding-bottom: 0.933333em; max-width: 35em; }
  .datinfo dt { flex: 1 1 50%; border-bottom: 1px solid #efefef; }
  .datinfo dd { flex: 1 1 50%; border-bottom: 1px solid #efefef; text-align: right; }
  .datinfo dd.ddprice { text-align: right; }
  .datinfo dl.bold dt,
  .datinfo dl.bold dd { font-weight: bold; }
  .ausstattung { padding: 0 0 1.83333em 0; }
  .datinfo h3 { font-weight: bold; padding: 0 0 0.6333333em 0; }
  
  .datinfo > h4 { padding: 0.111em 0.933333em 0; line-height: 1.2; cursor: pointer; position: relative; padding-left: 2em; }
  .datinfo > h4 span { display: block; width: 100%; }

	.datinfo .datinfo_container { border-top: 0 solid #ddd; padding: 0; height: 0; overflow: hidden; transition: height 0.3s, padding 0.3s; padding-left: 2em !important; }  
	.datinfo > h4 .fa-chevron-right { position: absolute; top: 1.133333em; left:0; width: 2em; text-align: center; font-size: 0.7rem; color: rgb(64,155,233);  transition: transform 0.2s; }

	.datinfo.openE .fa-chevron-right { transform: rotate(90deg); }
	.datinfo.openE .datinfo_container { height: auto; padding: 0.93333333em 0 2.43333333em 2em;  }
  
</style>